'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var google_heatmap = {};

exports.__exports = google_heatmap;
